<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ toggleVerticalNavMenuActive }">
      <div class="navbar-content-container">
        <div class="d-flex align-center">
          <v-icon v-if="$vuetify.breakpoint.mdAndDown" class="me-3" @click="toggleVerticalNavMenuActive">
            {{ icons.mdiMenu }}
          </v-icon>
        </div>

        <!-- Right Content: Light/Dark, User Dropdown -->
        <div class="d-flex align-center right-row">
          <app-bar-theme-switcher class="mr-4"></app-bar-theme-switcher>
          <app-bar-user-menu v-if="$route.meta.authenticated"></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer> </template>
  </layout-content-vertical-nav>
</template>

<script>
  import LayoutContentVerticalNav from "@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue";
  import AppBarUserMenu from "@/components/AppBarUserMenu.vue";
  import { fetchNavigationLinks } from "@/navigation/vertical";

  // App Bar Components
  import { getVuetify } from "@core/utils";
  import AppBarThemeSwitcher from "@core/layouts/components/app-bar/AppBarThemeSwitcher.vue";
  import { mdiHeartOutline, mdiMenu } from "@mdi/js";
  export default {
    components: {
      LayoutContentVerticalNav,
      AppBarThemeSwitcher,
      AppBarUserMenu,
    },
    setup() {
      const $vuetify = getVuetify();
      const navMenuItems = fetchNavigationLinks($vuetify.lang); // passes down translator into router

      return {
        navMenuItems,

        icons: {
          mdiMenu,
          mdiHeartOutline,
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .navbar-content-container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    position: relative;
  }
</style>
